import { render, staticRenderFns } from "./OnboardingProgressbar.vue?vue&type=template&id=da8c5806&scoped=true"
import script from "./OnboardingProgressbar.vue?vue&type=script&lang=js"
export * from "./OnboardingProgressbar.vue?vue&type=script&lang=js"
import style0 from "./OnboardingProgressbar.vue?vue&type=style&index=0&id=da8c5806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8c5806",
  null
  
)

export default component.exports